export { BackgroundImage } from '@mantine/core'